import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import getConfig from "./config";

let analytics;

const firebase = initializeApp(getConfig().firebase);

initializeFirestore(firebase, {
  ignoreUndefinedProperties: true,
});

if ("measurementId" in getConfig().firebase) {
  analytics = getAnalytics();
}

const auth = getAuth();
const db = getFirestore(firebase);
const storage = getStorage(firebase);

function refreshToken() {
  getAuth(firebase).onAuthStateChanged(async (user) => {
    if (user) {
      await user.getIdToken(true);
    }
  });
}

export { firebase, auth, db, storage, analytics, refreshToken };
